import { useState, useEffect, useCallback } from "react";
import * as reviewsApi from "@api/reviews.api";
import type { Statistics } from "@/types";

export interface UseStatisticsResult {
  stats: Statistics | null;
  loading: boolean;
  refetch: () => Promise<void>;
}

/**
 * Loads review aggregate statistics (dashboard, analytics).
 */
export function useStatistics(): UseStatisticsResult {
  const [stats, setStats] = useState<Statistics | null>(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    setLoading(true);
    try {
      setStats(await reviewsApi.getStatistics());
    } catch {
      setStats(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return { stats, loading, refetch };
}
